import React, { useState } from "react";
import styled from "@emotion/styled";
import theme from "theme";
import { apiPost } from "api/callApi";
import Label from "./Label";
import { validatePassword } from "utils/config";
import { Input } from "antd";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import { useNavigate } from "react-router";
import { Button } from "InnoUI/components";
import { showAlert } from "utils/helper";

const FormContainer = styled.div`
  max-width: 400px;
  margin: 50px auto;
  padding: 20px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  background-color: #fff;
`;

const Message = styled.div`
  font-size: 12px;
  margin: 0px 0px 10px 0px;
  color: ${(props) => (props.error ? "red" : "green")};
`;

const ChangePassword = () => {
  const [data, setData] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [message, setMessage] = useState({ text: "", error: false });
  const navigate = useNavigate();

  const handleChange = (property, value) => {
    setData((prevData) => ({
      ...prevData,
      [property]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage({ text: "", error: false });

    if (data.newPassword !== data.confirmPassword) {
      setMessage({
        text: "New password and confirm password do not match.",
        error: true,
      });
      return;
    }

    const { isValid, message: validationMessage } = validatePassword(
      data.newPassword
    );
    if (!isValid) {
      setMessage({
        text: validationMessage,
        error: true,
      });
      return;
    }

    try {
      const response = await apiPost("/v1/changepassword", data);
      if (response.status === "error") {
        setMessage({ text: response.message, error: true });
        return;
      }
      showAlert({ title: "Success", text: response.message, icon: "success" });
      setData({
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      });
      navigate("/");
    } catch (error) {
      console.error("Error changing password:", error);
      setMessage({
        text: error?.response?.data?.message,
        error: true,
      });
    }
  };

  return (
    <FormContainer>
      <h2>Change Password</h2>
      {message.text && <Message error={message.error}>{message.text}</Message>}
      <form onSubmit={handleSubmit}>
        <Label label="Old Password">
          <Input.Password
            iconRender={(visible) =>
              visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
            }
            name="oldPassword"
            placeholder="Old Password"
            value={data.oldPassword}
            onChange={(e) => handleChange("oldPassword", e.target.value)}
            required
          />
        </Label>
        <Label label="New Password">
          <Input.Password
            iconRender={(visible) =>
              visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
            }
            name="newPassword"
            placeholder="New Password"
            value={data.newPassword}
            onChange={(e) => handleChange("newPassword", e.target.value)}
            required
          />
        </Label>
        <Label label="Confirm Password">
          <Input.Password
            placeholder="Confirm Password"
            iconRender={(visible) =>
              visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
            }
            name="confirmPassword"
            value={data.confirmPassword}
            onChange={(e) => handleChange("confirmPassword", e.target.value)}
            required
          />
        </Label>
        <Button
          caption="Change Password"
          type="submit"
          color="white"
          fontSize="12px"
          style={{
            marginBottom: 8,
            background: theme.gradient.themeGradient,
            color: theme.colors.white,
            minWidth: "100%",
            height: "32px",
            borderRadius: "5px",
            padding: "12px",
            marginTop: "20px",
          }}
        />
      </form>
    </FormContainer>
  );
};

export default ChangePassword;
